import { Component } from '@angular/core';


@Component({
    template: `placeholder for host activation`
})
export class ActivateHostComponent {}
